export const LANGUAGES_RESET_STATE = 'LANGUAGES_RESET_STATE';
export const LANGUAGES_CURRENT_ITEM = 'LANGUAGES_CURRENT_ITEM';

export const LANGUAGES_REQUEST_LOADING = 'LANGUAGES_REQUEST_LOADING';
export const LANGUAGES_REQUEST_SUCCESS = 'LANGUAGES_REQUEST_SUCCESS';
export const LANGUAGES_REQUEST_FAILED = 'LANGUAGES_REQUEST_FAILED';

export const LANGUAGES_CURRENT_ACTION = 'LANGUAGES_CURRENT_ACTION';
export const LANGUAGES_RESET_ACTION = 'LANGUAGES_RESET_ACTION';